/*** IMPORTS FROM imports-loader ***/
(function() {

define(['window'], function (window) {
    return {
        getCookieDomain: function () {
            var currentHost = window.location.hostname;
            return currentHost.indexOf('qa') > 0 ? "." + currentHost : ".homedepot.com";
        },
        getDomain: function () {
            var domain = '//www.homedepot.com';
            if(window.location.origin.indexOf('local') > 0){
                return domain;
            }
            return window.location.origin;
        }
    }
});

}.call(window));